const newContainer = () => import("@/layouts/Default.vue");
const ProfileRequiredTabsLayout = () =>
  import("@/layouts/ProfileRequiredTabsLayout.vue");
const routerParent = () => import("@/layouts/routerParrent.vue");
const companyList = () => import("../views/company/companyList.vue");
const companyEdit = () => import("../views/company/companyEdit.vue");
const companyInformationEdit = () =>
  import("../views/company/company-information/companyInformationEdit.vue");
const companyContactsEdit = () =>
  import("../views/company/company-contacts/companyContactsEdit.vue");
const companyAddressEdit = () =>
  import("../views/company/company-address/companyAddressEdit.vue");
const companyAttachmentsEdit = () =>
  import("../views/company/company-attachments/companyAttachmentsEdit.vue");
const specialAttachmentsEdit = () =>
  import(
    "../views/profile/profileTabs/special-attachments/specialAttachmentsEdit.vue"
  );
const profileAttachmentsEdit = () =>
  import(
    "../views/profile/profileTabs/profile-attachments/profileAttachmentsEdit.vue"
  );

const whatsNewList = () => import("../views/whats-new/whats-new-list.vue");

const relatedTest = () =>
  import("../views/profile/profileTabs/relatedTest/RelatedTestView.vue");
const rolesList = () => import("../views/roles/rolesList.vue");

const rolesAdd = () => import("../views/roles/rolesAdd.vue");
const rolesEdit = () => import("../views/roles/rolesEdit.vue");
const rolePermissions = () => import("../views/roles/rolePermissions.vue");
const SearchEnum = () => import("../views/enum/SearchEnum.vue");
const EditableEnum = () => import("../views/enum/EditableEnum.vue");

// /* redesign */

const searchParvandeh = () => import("../views/parvandeh/searchParvandeh.vue");

const addParvandeh = () => import("../views/parvandeh/addParvandeh.vue");
const editParvandeh = () => import("../views/parvandeh/editParvandeh.vue");
const parvandehCancel = () =>
  import("../views/parvandeh/parvandeh-cancel/index.vue");
const termsList = () => import("../views/term/termsList.vue");
const editTerm = () => import("../views/term/editTerm.vue");
const changeUserInformation = () =>
  import("../views/change-user-information/changeUserInformation.vue");
const selfProfile = () =>
  import("../views/profile/profilePage/selfProfile.vue");
const otherProfile = () =>
  import("../views/profile/profilePage/otherProfile.vue");
const EditeIdentity = () =>
  import("../views/profile/profileTabs/identity/EditIdentity.vue");
const EditeContact = () =>
  import("../views/profile/profileTabs/contact/EditContact.vue");
const EditeAddress = () =>
  import("../views/profile/profileTabs/address/EditAddress.vue");
const EditeWorkExperience = () =>
  import("../views/profile/profileTabs/work/EditWorkExperience.vue");
const EditeEducation = () =>
  import("../views/profile/profileTabs/education/EditEducation.vue");
const EditSocial = () =>
  import("../views/profile/profileTabs/social/EditSocial.vue");
const EditInformation = () =>
  import("../views/profile/profileTabs/information/EditInformation.vue");

const EditquoteInfo = () =>
  import("../views/profile/profileTabs/quoteInfo/EditquoteInfo.vue");
const EditLicenses = () =>
  import("../views/profile/profileTabs/licenses/EditLicense.vue");
const EditCourse = () =>
  import("../views/profile/profileTabs/course/EditCourse.vue");
const EditArticles = () =>
  import("../views/profile/profileTabs/articles/EditArticles.vue");
const EditWifeInfo = () =>
  import("../views/profile/profileTabs/wifeInfo/EditWifeInfo.vue");
const EditFamilyRelation = () =>
  import("../views/profile/profileTabs/familyRelation/EditFamilyRelation.vue");
const EditYearsOfService = () =>
  import("../views/profile/profileTabs/yearsOfService/EditYearsOfService.vue");
const EditTeachingExperience = () =>
  import(
    "../views/profile/profileTabs/teachingExperience/EditTeachingExperience.vue"
  );
const EditRepresentative = () =>
  import("../views/profile/profileTabs/representative/EditRepresentative.vue");
const EditFinancialInformation = () =>
  import(
    "../views/profile/profileTabs/financialInformation/EditfinancialInformation.vue"
  );
const EditSkills = () =>
  import("../views/profile/profileTabs/skills/EditSkills.vue");
const EditPersonRelation = () =>
  import("../views/profile/profileTabs/personRelation/EditPersonRelation.vue");

// folder
const folderList = () => import("../views/folder/folderList.vue");

const personIdentityList = () =>
  import("../views/person-identity/personIdentityList.vue");
const activeUsersList = () =>
  import("../views/users/active-users/activeUsersList.vue");
const blockedUsersList = () =>
  import("../views/users/blocked-users/blockedUsersList.vue");

const hozehGhazayiList = () =>
  import("../views/hozeh-ghazayi/hozehGhazayiList.vue");
const selectProvince = () =>
  import("../views/hozeh-ghazayi/select-province/selectProvince.vue");
const selectDetail = () =>
  import("../views/hozeh-ghazayi/select-detail/selectDetail.vue");

const hozehGhazayiSettingForTermList = () =>
  import("../views/hozeh-ghazayi/hozehGhazayiSettingForTermList.vue");
const profileAzmoonList = () =>
  import("../views/profile/parvandehTabs/azmoon/profileAzmoonList.vue");
const licenseFieldList = () =>
  import("../views/license/license-field/licenseFieldList.vue");
const termLicenseFieldList = () =>
  import("../views/license/term-license-field/termLicenseFieldList.vue");

const ProfileRequiredTabs = () =>
  import("../views/profile-required-tabs/profileRequiredTabs.vue");

export const profileRoutes: any[] = [
  {
    path: "/profile",
    name: "profile_page",
    meta: {
      label: "خانه",
      requiresAuth: true,
      moduleName: "profile",
    },
    component: newContainer,
    children: [
      {
        path: "company",
        name: "company",
        meta: {
          label: "شرکت",
          requiresAuth: true,
        },
        component: routerParent,
        redirect: "/profile/company/list",
        children: [
          {
            path: "list",
            name: "company-list",
            component: companyList,
            meta: {
              label: "لیست شرکت‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "edit/:code",
            name: "company-edit",
            component: companyEdit,
            meta: {
              label: "ویرایش شرکت",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/information",
            name: "company-information",
            component: companyInformationEdit,
            meta: {
              label: "ویرایش شرکت",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/contacts",
            name: "company-contacts",
            component: companyContactsEdit,
            meta: {
              label: "اطلاعات تماس",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/address",
            name: "company-address",
            component: companyAddressEdit,
            meta: {
              label: "اطلاعات آدرس",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/attachments",
            name: "company-attachments",
            component: companyAttachmentsEdit,
            meta: {
              label: "پیوست‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "person-identity",
        name: "person-identity-list",
        component: routerParent,
        redirect: "/profile/person-identity/list",
        meta: {
          label: "تغییر اطلاعات هویتی",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "person_identity_change",
            component: personIdentityList,
            meta: {
              label: "درخواست‌های تغییر اطلاعات هویتی",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "users",
        name: "users",
        // component: routerParent,
        redirect: "/profile/users/search",
        meta: {
          label: "کاربر",
          requiresAuth: true,
        },
        children: [
          {
            path: "search",
            name: "searchUser",
            // component: searchUser,
            meta: {
              label: "جستجوی کاربر",
              requiresAuth: true,
            },
          },
          {
            path: "add",
            name: "AddUser",
            // component: AddUser,
            meta: {
              label: "درج کاربر",
              requiresAuth: true,
            },
          },
          {
            path: "edit/:code",
            name: "editUser",
            // component: editUser,
            meta: {
              label: "ویرایش کاربر",
              requiresAuth: true,
            },
          },
          {
            path: "change_pass",
            name: "changePassword",
            // component: changePassword,
            meta: {
              label: "تغییر گذرواژه",
              requiresAuth: true,
            },
          },
          {
            path: "change-mobile",
            name: "change_mobile",
            // component: changeMobile,
            meta: {
              label: "تغییر شماره همراه",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "parvandeh",
        name: "parvandeh",
        component: routerParent,
        redirect: "/profile/parvandeh/list",
        meta: {
          label: "پرونده‌",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "parvandeh-list",
            component: searchParvandeh,
            meta: {
              label: "پرونده‌های افراد",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "search-archive",
            name: "parvandeh_archive",
            // component: searchParvandehArchive,
            meta: {
              label: "پرونده‌های مختومه",
            },
          },
          {
            path: "add",
            name: "add-parvandeh",
            component: addParvandeh,
            meta: {
              label: "ایجاد پرونده جدید",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "edit/:code",
            name: "edit-parvandeh",
            component: editParvandeh,
            meta: {
              label: "گزینه‌های بیشتر",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "search/:parvandeh_number?",
            name: "parvandeh_by_number",
            // component: searchParvandeh,
            meta: {
              label: "پرونده‌های افراد",
              requiresAuth: true,
            },
          },
          {
            path: "cancel",
            name: "parvandeh_cancel",
            component: parvandehCancel,
            meta: {
              label: "درخواست انصراف از پرونده",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/azmoon-list",
            name: "profile-azmoon-list",
            component: profileAzmoonList,
            meta: {
              label: "آزمون‌های فرد",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "report-access",
        name: "report_access",
        // component: routerParent,
        redirect: "/profile/report-access/search",
        meta: {
          label: "دسترسی به گزارش‌های بارگذاری شده",
          requiresAuth: true,
        },
        children: [
          {
            path: "search",
            name: "report-access-search",
            // component: searchReportAccess,
            meta: {
              label: "لیست دسترسی به گزارش‌های بارگذاری شده",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "term",
        name: "term-page",
        component: routerParent,
        redirect: "/profile/term/list",
        meta: {
          label: "دوره‌ها",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "term",
            component: termsList,
            meta: {
              label: "لیست دوره‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },

          {
            path: "edit/:code",
            name: "edit-term",
            component: editTerm,
            meta: {
              label: "ویرایش دوره",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "person",
        name: "person-page",
        // component: routerParent,
        redirect: "/profile/person/search",
        meta: {
          label: "فرد",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "search",
            name: "searchPerson",
            // component: searchPerson,
            meta: {
              label: "جستجوی فرد",
              requiresAuth: true,
            },
          },
          {
            path: "add",
            name: "addPerson",
            // component: AddPerson,
            meta: {
              label: "ثبت فرد",
              requiresAuth: true,
            },
          },
          {
            path: "edit/:code/:target?",
            name: "editPerson",
            // component: personPage,
            meta: {
              label: "ویرایش نمایه فردی",
              requiresAuth: true,
            },
          },
          {
            path: ":code/DesignPdfPage",
            name: "DesignPdfPage",
            // component: DesignPdfPage,
            meta: {
              label: "اطلاعات فردی",
              requiresAuth: true,
            },
          },
        ],
      },
      // start modified profile routed
      {
        path: "self",
        name: "profile-page",
        component: routerParent,
        meta: {
          label: "نمایه من",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: ":code?/edit",
            name: "profile",
            component: selfProfile,
            meta: {
              label: "ویرایش نمایه من",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
            },
          },
          {
            path: ":code?/identity",
            name: "profile-identity",
            component: EditeIdentity,
            meta: {
              label: "مشخصات اصلی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/information",
            name: "profile-information",
            component: EditInformation,
            meta: {
              label: "ویرایش اطلاعات تکمیلی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/contact",
            name: "profile-contact",
            component: EditeContact,
            meta: {
              label: "ویرایش اطلاعات تماس",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/address",
            name: "profile-address",
            component: EditeAddress,
            meta: {
              label: "ویرایش اطلاعات آدرس",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/work-experience",
            name: "profile-work-experience",
            component: EditeWorkExperience,
            meta: {
              label: "ویرایش سوابق شغلی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/education",
            name: "profile-education",
            component: EditeEducation,
            meta: {
              label: "ویرایش سوابق تحصیلی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/socail",
            name: "profile-social",
            component: EditSocial,
            meta: {
              label: "ویرایش سوابق فرهنگی اجتماعی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/quote",
            name: "profile-quote",
            component: EditquoteInfo,
            meta: {
              label: "ویرایش سهمیه ایثارگری",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/license",
            name: "profile-license",
            component: EditLicenses,
            meta: {
              label: "ویرایش مجوز‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/course",
            name: "profile-course",
            component: EditCourse,
            meta: {
              label: "ویرایش دوره‌ها و همایش‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/article",
            name: "profile-article",
            component: EditArticles,
            meta: {
              label: "ویرایش مقاله‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/wife-info",
            name: "profile-wife-info",
            component: EditWifeInfo,
            meta: {
              label: "ویرایش مشخصات همسر",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/family-relation",
            name: "profile-family-relation",
            component: EditFamilyRelation,
            meta: {
              label: "ویرایش اعضا خانواده",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/financial-information",
            name: "profile-financial-information",
            component: EditFinancialInformation,
            meta: {
              label: "ویرایش اطلاعات مالی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/year-of-service",
            name: "profile-year-of-service",
            component: EditYearsOfService,
            meta: {
              label: "ویرایش سوابق خدمت",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/teaching-experience",
            name: "profile-teaching-experience",
            component: EditTeachingExperience,
            meta: {
              label: "ویرایش سوابق تدریس",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/representative",
            name: "profile-representative",
            component: EditRepresentative,
            meta: {
              label: "ویرایش معرف",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/relation/:id?/:relation_with",
            name: "profile-relation",
            component: EditPersonRelation,
            meta: {
              label: "ویرایش افراد مرتبط",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/skills",
            name: "profile-skills",
            component: EditSkills,
            meta: {
              label: "ویرایش مهارت‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/attachments",
            name: "profile-attachments",
            component: profileAttachmentsEdit,
            meta: {
              label: "پیوست‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code?/azmoon",
            name: "profile-azmoon",
            component: relatedTest,
            meta: {
              label: "آزمون‌های مرتبط",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "other",
        name: "person-page",
        component: routerParent,
        meta: {
          label: "نمایه فردی",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: ":code/parvandeh/:parvandehCode/edit",
            name: "person",
            component: otherProfile,
            meta: {
              label: "ویرایش نمایه فردی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/identity",
            name: "person-identity",
            component: EditeIdentity,
            meta: {
              label: "مشخصات اصلی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/contact",
            name: "person-contact",
            component: EditeContact,
            meta: {
              label: "ویرایش اطلاعات تماس",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/information",
            name: "person-information",
            component: EditInformation,
            meta: {
              label: "ویرایش اطلاعات تکمیلی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/address",
            name: "person-address",
            component: EditeAddress,
            meta: {
              label: "ویرایش اطلاعات آدرس",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/work-experience",
            name: "person-work-experience",
            component: EditeWorkExperience,
            meta: {
              label: "ویرایش سوابق شغلی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/education",
            name: "person-education",
            component: EditeEducation,
            meta: {
              label: "ویرایش سوابق تحصیلی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/socail",
            name: "person-social",
            component: EditSocial,
            meta: {
              label: "ویرایش سوابق فرهنگی اجتماعی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/quote",
            name: "person-quote",
            component: EditquoteInfo,
            meta: {
              label: "ویرایش سهمیه ایثارگری",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/license",
            name: "person-license",
            component: EditLicenses,
            meta: {
              label: "ویرایش مجوز‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/course",
            name: "person-course",
            component: EditCourse,
            meta: {
              label: "ویرایش دوره‌ها و همایش‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/article",
            name: "person-article",
            component: EditArticles,
            meta: {
              label: "ویرایش مقاله‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/wife-info",
            name: "person-wife-info",
            component: EditWifeInfo,
            meta: {
              label: "ویرایش مشخصات همسر",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/family-relation",
            name: "person-family-relation",
            component: EditFamilyRelation,
            meta: {
              label: "ویرایش اعضا خانواده",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/financial-information",
            name: "person-financial-information",
            component: EditFinancialInformation,
            meta: {
              label: "ویرایش اطلاعات مالی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/year-of-service",
            name: "person-year-of-service",
            component: EditYearsOfService,
            meta: {
              label: "ویرایش سوابق خدمت",
              requiresAuth: true,
              redesigned: true,
            },
          },

          {
            path: ":code/parvandeh/:parvandehCode/teaching-experience",
            name: "person-teaching-experience",
            component: EditTeachingExperience,
            meta: {
              label: "ویرایش سوابق تدریس",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/representative",
            name: "person-representative",
            component: EditRepresentative,
            meta: {
              label: "ویرایش معرف",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/relation/:id?/:relation_with",
            name: "person-relation",
            component: EditPersonRelation,
            meta: {
              label: "ویرایش افراد مرتبط",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/skills",
            name: "person-skills",
            component: EditSkills,
            meta: {
              label: "ویرایش مهارت‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/special-attachments",
            name: "person-special-attachments",
            component: specialAttachmentsEdit,
            meta: {
              label: "پیوست‌های ویژه",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/attachments",
            name: "person-attachments",
            component: profileAttachmentsEdit,
            meta: {
              label: "پیوست‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/azmoon",
            name: "person-azmoon",
            component: relatedTest,
            meta: {
              label: "آزمون‌های مرتبط",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "roles",
        name: "role",
        redirect: "/profile/roles/list",
        component: routerParent,
        meta: {
          label: "نقش‌ها",
          requiresAuth: true,
        },
        children: [
          {
            path: "list",
            name: "roles-list",
            component: rolesList,
            meta: {
              label: "نقش‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/add",
            name: "roles-add",
            component: rolesAdd,
            meta: {
              label: "نقش جدید",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/edit",
            name: "roles-edit",
            component: rolesEdit,
            meta: {
              label: "اصلاح نقش",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/permissions",
            name: "role-permissions",
            component: rolePermissions,
            meta: {
              label: "تعیین سطح دسترسی نقش",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "access",
            name: "roles-access-list",
            meta: {
              label: "دسترسی‌های یک منبع برای تمام نقش‌ها",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "applyLicense",
        name: "apply_license",
        redirect: "/profile/applyLicense/search",
        // component: routerParent,
        meta: {
          label: "کاربری",
          requiresAuth: true,
        },
      },
      {
        path: "register",
        name: "register-old",
        redirect: "/profile/register",
        // component: routerParent,
        meta: {
          label: "اطلاعات کاربری",
          requiresAuth: true,
        },
        children: [
          {
            path: "/",
            name: "register",
            // component: newRegister,
            meta: {
              label: "ثبت‌نام",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "enumeration",
        name: "enumeration",
        redirect: "/profile/enumeration/list",
        // component: routerParent,
        meta: {
          label: "مقادیر پایه",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "enumeration-list",
            component: EditableEnum,
            meta: {
              label: "عنوان دسته بندی",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":category/search",
            name: "searchEnumeration",
            component: SearchEnum,
            meta: {
              label: "جستجوی مقادیر پایه",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "add",
            name: "addEnum",
            // component: AddEnum,
            meta: {
              label: "درج مقادیر پایه",
            },
          },
          {
            path: "edit/:id",
            name: "editEnum",
            // component: EditEnum,
            meta: {
              label: "ویرایش مقادیر پایه",
            },
          },
        ],
      },
      {
        path: "hozeh-ghazayi",
        name: "hozeh_ghazayi",
        component: routerParent,
        redirect: "/profile/hozeh-ghazayi/list",
        meta: {
          label: "حوزه قضایی",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "all_hozeh_ghazayi",
            component: hozehGhazayiList,
            meta: {
              label: "لیست حوزه‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "term-list",
            name: "hozeh_ghazayi_term",
            component: hozehGhazayiSettingForTermList,
            meta: {
              label: "تنظیمات حوزه برای دوره",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "select-province",
            name: "person_hozeh_ghazayi",
            component: selectProvince,
            meta: {
              label: "انتخاب حوزه استانی",
              requiresAuth: true,
              redesigned: true,
              hasMaxWidth: false,
              hasBottomNavigation: false,
            },
          },
          {
            path: "select-detail",
            name: "select_hozeh_ghazayi_detail",
            component: selectDetail,
            meta: {
              label: "انتخاب حوزه نهایی",
              requiresAuth: true,
              redesigned: true,
              hasMaxWidth: false,
              hasBottomNavigation: false,
            },
          },
        ],
      },
      {
        path: "whats-new",
        name: "whats_new",
        component: routerParent,
        redirect: "/profile/whats-new/list",
        meta: {
          label: "تاریخچه تغییرات سامانه",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "whats-new-list",
            component: whatsNewList,
            meta: {
              label: "تاریخچه تغییرات سامانه",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "folder",
        name: "folder",
        component: routerParent,
        redirect: "/profile/folder/list",
        meta: {
          label: "دسته بندی",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "folder-list",
            component: folderList,
            meta: {
              label: "دسته بندی",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "active-users",
        name: "active-users",
        component: routerParent,
        redirect: "/profile/active-users/list",
        meta: {
          label: "کاربران فعال در سامانه",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "active_user_history",
            component: activeUsersList,
            meta: {
              label: "کاربران فعال در سامانه",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "blocked-users",
        name: "blocked-users",
        component: routerParent,
        redirect: "/profile/blocked-users/list",
        meta: {
          label: "کاربران مسدود شده",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "blocked-users-list",
            component: blockedUsersList,
            meta: {
              label: "کاربران مسدود شده",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "change-user-information",
        name: "change-user-information",
        component: changeUserInformation,
        meta: {
          label: "تغییر مشخصات کاربری",
          requiresAuth: true,
          redesigned: true,
        },
      },
      {
        path: "license-field",
        name: "license_field",
        component: routerParent,
        redirect: "/profile/license-field/list",
        meta: {
          label: "لیست رشته های تخصصی",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "license-field-list",
            component: licenseFieldList,
            meta: {
              label: "لیست رشته های تخصصی",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "term-license-field",
        name: "term_license_field",
        component: routerParent,
        redirect: "/profile/term-license-field/list",
        meta: {
          label: "رشته های تخصصی هر دوره",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "term-license-field-list",
            component: termLicenseFieldList,
            meta: {
              label: "رشته های تخصصی هر دوره",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/profile-required-tabs",
    name: "profile-required-tabs",
    redirect: "/profile-required-tabs/start",
    component: ProfileRequiredTabsLayout,
    meta: {
      redesigned: true,
      moduleName: "profile",
      requiresAuth: true,
    },
    children: [
      {
        path: "start",
        name: "profile-required-tabs-start",
        component: ProfileRequiredTabs,
        meta: {
          redesigned: true,
          requiresAuth: true,
          label: "صفحه اطلاعات تکمیلی ثبت‌نام",
        },
      },
    ],
  },
];
